// extracted by css-extract-rspack-plugin
export default {"issueCountBadges":"yWRAfwc7hMa4tuua"};